import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from "vue";
import chat from "@/components/chat/chat.vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { gaEvent } from "@/utils/format";
import phoneItem from "@/views/instagram/leftTabs/phoneItem.vue";
import phoneContentItem from "@/views/instagram/rightContent/phoneContentItem.vue";
import chatContentItem from "@/views/instagram/rightContent/chatContentItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'instagram',
  setup(__props) {

const store = useStore();

const appInfo = {
  name: "Instagram",
  // name: "Whatsapp",
  icon: require("@/assets/chat/instagram-icon.svg"),
};

store.commit("setCurrentMonitorApp", {
  category: "Instagram_Function",
  eventNamePre: "Instagram",
});
const currentMonitorApp = computed(() => store.state.currentMonitorApp);

// console.log(currentMonitorApp.value, "currentMonitorApp");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(chat, {
    appInfo: appInfo,
    tabs: ['Contact', 'Mail', 'Phone']
  }, {
    chatContentItem: _withCtx(({ msgObj }) => [
      _createVNode(chatContentItem, _normalizeProps(_guardReactiveProps(msgObj)), null, 16)
    ]),
    phoneItem: _withCtx(({ item }) => [
      _createVNode(phoneItem, { item: item }, null, 8, ["item"])
    ]),
    phoneContentItem: _withCtx(({ phoneItemDetail }) => [
      _createVNode(phoneContentItem, { phoneItemDetail: phoneItemDetail }, null, 8, ["phoneItemDetail"])
    ]),
    _: 1
  }))
}
}

})